
namespace Sintra {

	export class NavigationHistoryItem {

		private _index: number;
		private _value: any;

		constructor(index: number, value: any) {
			this._index = index;
			this._value = value;
		}

		public get index() { return this._index; }

		public get value() { return this._value; }
	}

	export class NavigationHistory {

		private _items: NavigationHistoryItem[];
		private _currentItem: NavigationHistoryItem;
		private _previousItem: NavigationHistoryItem;
		private _nextItem: NavigationHistoryItem;
		private _canGoBack: boolean;
		private _canGoNext: boolean;

		private _changedHandlers: Array<(history: NavigationHistory) => void>;

		constructor() {
			this._changedHandlers = [];
			this.clear();
		}


		private _triggerHistoryChangedEvent() {
			for (const handler of this._changedHandlers) {
				handler(this);
			}
		}

		private _findFirstItem(value: any) {
			return this._items.filter(x => x.value === value)[0];
		}

		private _setCurrentItem(item: NavigationHistoryItem) {
			if (this._currentItem === item) {
				return;
			}
			if (item && item.index > 0) {
				this._canGoBack = true;
				this._previousItem = this._items[item.index - 1];
			}
			else {
				this._canGoBack = false;
				this._previousItem = null;
			}
			const nextIndex = item.index + 1;
			this._canGoNext = nextIndex <= (this._items.length - 1);
			this._nextItem = this._canGoNext ? this._items[nextIndex] : null;
			this._currentItem = item;
			this._triggerHistoryChangedEvent();
		}

		public pushAndGoTo(value: any) {
			if (this.currentItem && this.currentItem.index < (this._items.length - 1)) {
				// current is not the last item
				// remove all items after current, before navigate
				this._items = this._items.slice(0, this.currentItem.index + 1);
			}
			const item = new NavigationHistoryItem(this._items.length, value);
			this._items.push(item);
			this._setCurrentItem(item);
		}

		public get currentItem() { return this._currentItem; }

		public get previousItem() { return this._previousItem; }

		public get nextItem() { return this._nextItem; }

		public get canGoBack() { return this._canGoBack; }

		public get canGoNext() { return this._canGoNext; }


		public addChangedHandler(handler: (history: NavigationHistory) => void) {
			if (this._changedHandlers.indexOf(handler) < 0) {
				this._changedHandlers.push(handler);
			}
		}

		public removeChangedHandler(handler: (history: NavigationHistory) => void) {
			const index = this._changedHandlers.indexOf(handler);
			if (index >= 0) {
				this._changedHandlers = this._changedHandlers.splice(index, 1);
			}
		}

		public goBack(value?: any, clearNexts = false) {
			if (this._canGoBack) {

				let backIndex = -1;
				if (value) {
					const foundItem = this._findFirstItem(value);
					if (!foundItem) {
						console.error(`invalid history value '${value}'`);
						return;
					}
					backIndex = foundItem.index;
				}
				else {
					backIndex = this._currentItem.index - 1;
				}

				if (clearNexts) {
					this._items = this._items.slice(0, backIndex + 1);
				}
				this._setCurrentItem(this._items[backIndex]);
			}
		}

		public goNext() {
			if (this._canGoNext) {
				const nextIndex = this._currentItem.index + 1;
				this._setCurrentItem(this._items[nextIndex]);
			}
		}

		public contains(value: any) {
			return this._items.some(x => x.value === value);
		}

		public clear() {
			this._currentItem = null;
			this._previousItem = null;
			this._items = [];
			this._canGoBack = false;
			this._canGoNext = false;
			this._triggerHistoryChangedEvent();
		}
	}
}